(() => {
  const expandDesignerFilter = (root = document) => {
    root.querySelectorAll('input[name="filter.p.vendor"]').forEach((input) => {
      const scope = input.closest('details.js-filter');
      if (!scope) return;

      scope.querySelectorAll('.facets__item.show-more-item').forEach((item) => {
        item.classList.remove('show-more-item', 'hidden');
        item.hidden = false;
      });

      const showMore = scope.querySelector('show-more-button');
      if (showMore) showMore.hidden = true;
    });
  };

  const run = () => requestAnimationFrame(() => expandDesignerFilter(document));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('arca:facets-updated', run);
  document.addEventListener('shopify:section:load', run);
})();
